import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';

import { IMenuItemProps } from '@amobee/component-library/dist';
import { ReactWrapperComponent } from '@angular-react/core';

@Component({
    selector: 'app-menu-item',
    exportAs: 'appMenuItem',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: ['react-renderer'],
    template: `
        <MenuItem #reactNode 
            [label]="label" 
            [value]="value" 
            [disabled]="disabled"
            (onClick)="handleOnClick($event)">
        </MenuItem>
    `
})
export class MenuItemComponent extends ReactWrapperComponent<IMenuItemProps> {
    @Input('label') public label: IMenuItemProps['label'];
    @Input('value') public value?: IMenuItemProps['value'];
    @Input('disabled') public disabled?: IMenuItemProps['disabled'];

    @Output() public readonly itemClick = new EventEmitter<any>();

    @ViewChild('reactNode', { static: true })
    protected reactNodeRef: ElementRef;

    constructor(elementRef: ElementRef, changeDetectorRef: ChangeDetectorRef, renderer: Renderer2) {
        super(elementRef, changeDetectorRef, renderer);
    }

    public handleOnClick($event) {
        this.itemClick.emit($event);
    }
}
